import React, { FC } from 'react';
import { Container, Grid, makeStyles, Theme } from '@material-ui/core';
import { CurrentLocationCoordinates } from 'interfaces/components';
import clsx from 'clsx';
import { GoogleMapComponent, ContactDescription } from 'containers/common/sections/contact-us';

interface ContactUsProps {
  currentLocation: CurrentLocationCoordinates;
  hideElements?: boolean;
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      marginTop: 144,

      [theme.breakpoints.down('md')]: {
        marginTop: 40,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 72,
      },

      '& a': {
        display: 'none',
      },
    },
    newRoot: {
      marginTop: 0,
    },
    mapContact: {
      position: 'relative',
      '& > div': {
        '&:nth-child(1)': {
          position: 'relative',
          zIndex: 11,
          height: '519px !important',
          [theme.breakpoints.down('sm')]: {
            height: '100% !important',
          },
        },
        '& > div': {
          borderRadius: ({ hideElements }: Partial<ContactUsProps>) => (hideElements ? 20 : 6),
        },
      },
      [theme.breakpoints.down('sm')]: {
        height: 300,
        margin: ({ hideElements }: Partial<ContactUsProps>) =>
          theme.spacing(0, hideElements ? 0 : 4),
        padding: '6px !important',
      },
    },
  };
});
const ContactLocation: FC<ContactUsProps> = ({ currentLocation, hideElements, className }) => {
  const classes = useStyles({ hideElements });
  return (
    <Grid className={className}>
      <Container
        maxWidth={false}
        fixed
        className={clsx(classes.root, hideElements && classes.newRoot)}
      >
        <Grid container justifyContent={'space-between'}>
          {!hideElements && (
            <Grid xs={12} sm={12} md={3} item>
              <ContactDescription title={'Office location'} />
            </Grid>
          )}
          <Grid
            xs={12}
            sm={12}
            md={hideElements ? 12 : 9}
            className={classes.mapContact}
            id={'map'}
            item
          >
            <GoogleMapComponent currentLocation={currentLocation} />
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default ContactLocation;
